const posts = [
  {
    id: 1,
    username: "amit",
    displayName: "Amit Rout",
    userimage: "https://avatars.githubusercontent.com/u/48612930?v=4",
    image:
      "https://images.unsplash.com/photo-1650668301912-ea5a313b00b4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxOXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60",
    description: "Hills",
    comments: [{ id: 101, comment: "beautiful", username: "rahul" }],
  },
  {
    id: 2,
    username: "Jaky12",
    displayName: "Jatin Sahoo",
    userimage:
      "https://images.unsplash.com/photo-1650594122465-7608fcd64620?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw1NHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60",

    image:
      "https://images.unsplash.com/photo-1650634665444-c9874a012056?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw0M3x8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60",
    description: "Fireworks!!",
    comments: [{ id: 102, comment: "Wow!", username: "yasin" }],
  },
];
export default posts;
